import { createSelector } from 'reselect';

const selectLocation = (state) => state.location;

const selectLocationList = createSelector(
	selectLocation,
	(location) => location?.list
);

const getLocationsAddress = createSelector(
	selectLocation,
	(location) => location?.address
);

const getNeshanPosition = createSelector(
	selectLocation,
	(location) => location?.neshanPosition
);

const locationSelectors = {
	selectLocation,
	selectLocationList,
	getLocationsAddress,
	getNeshanPosition,
};

export default locationSelectors;
